type Props = {
    placeholder?: string,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => any,
    value?: string,
    clearSearch?: () => any,
}

const SearchField: React.FC<Props> = ({placeholder, value, onChange, clearSearch}) => {
    return (
        <label className="relative block">
            <span className="sr-only">Search</span>
            <span className="absolute inset-y-0 left-0 flex items-center">
                {value?
                <i className="ri-close-circle-fill text-gray-400 text-xl cursor-pointer" onClick={clearSearch} />
                :
                <i className="ri-search-2-line text-gray-400 text-xl" />
                }
            </span>
            <input className="placeholder-gray-400 block bg-transparent w-full border-b border-slate-300 dark:border-slate-800 py-2 pl-7 pr-3 shadow-sm focus:outline-none focus:border-b-orange-400" 
                type="text" name="search" value={value || ''} onChange={onChange} placeholder={placeholder || "Search for anything..."} autoComplete="off"
            />
        </label>
    )
}

export default SearchField